/**
 * Tapering — docs/33 C4. "1-1-1 x 3d then 1-0-1 x 3d then 1-0-0 x 3d":
 * the shorthand split into stages, and each stage's dates, one after the
 * other. Every stage but the last needs its own "x Nd": a stage with no end
 * would never let the next one begin.
 */
import { addDaysToLocalDate } from './time.js';
import type { LocalDate } from './types.js';

/** The stages as typed, or one part when there is no "then". */
export function splitStages(input: string): string[] {
  return input.split(/\s+then\s+|\s*→\s*|\s*->\s*/i).map((s) => s.trim()).filter(Boolean);
}

export interface StageDates {
  startDate: LocalDate;
  endDate: LocalDate | null;
}

/**
 * Dates for each stage from its length in days, the first starting on
 * `start`. Null when a stage before the last has no length.
 */
export function stageDates(lengths: readonly (number | undefined)[], start: LocalDate): StageDates[] | null {
  const out: StageDates[] = [];
  let from = start;
  for (let i = 0; i < lengths.length; i++) {
    const n = lengths[i];
    const last = i === lengths.length - 1;
    if (n === undefined || !Number.isInteger(n) || n < 1) {
      if (!last) return null;
      out.push({ startDate: from, endDate: null });
      break;
    }
    const end = addDaysToLocalDate(from, n - 1);
    out.push({ startDate: from, endDate: end });
    from = addDaysToLocalDate(end, 1);
  }
  return out;
}
